import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'JoinOmu has completely transformed my weight loss journey. The continuous support from my doctor and the convenience of the platform make it so much easier to stay on track.',
    author: 'Sarah K.',
    role: 'Weight Loss Patient',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
  }, {
    quote: 'As a provider, JoinOmu allows me to focus on patient care rather than paperwork. The platform streamlines everything, and I can deliver better care to my patients than I ever could in traditional practice.',
    author: 'Dr. James Wilson',
    role: 'Healthcare Provider',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
  }, {
    quote: "The men's health program at JoinOmu has been life-changing. The discrete, professional care and the convenience of having medications delivered directly to my door have made this experience exceptional.",
    author: 'Michael T.',
    role: "Men's Health Patient",
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const nextTestimonial = () => {
    setActiveIndex(prev => (prev + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setActiveIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="hidden py-24 relative overflow-hidden" data-id="element-309">
      {/* Decorative elements */}
      <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-[#BBDDFF]/10 blur-3xl" data-id="element-310"></div>
      <div className="absolute -bottom-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-[#C85A15]/5 blur-3xl" data-id="element-311"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-312">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-313">
          <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 backdrop-blur-sm border border-white/10" data-id="element-314">
            <span className="text-sm font-medium" data-id="element-315">Success Stories</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-316">
            <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-317">
              Hear from our community
            </span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-318">
            Real stories from patients and providers who have experienced the
            JoinOmu difference.
          </p>
        </div>
        <div className="relative max-w-4xl mx-auto" data-id="element-319">
          <div className="absolute inset-0 bg-gradient-to-br from-[#BBDDFF]/20 to-[#C85A15]/20 rounded-3xl blur-xl" data-id="element-320"></div>
          <div className="relative bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-8 md:p-12 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-321">
            <div className="flex flex-col items-center text-center" data-id="element-322">
              <div className="w-20 h-20 rounded-full overflow-hidden mb-6 border-4 border-[#BBDDFF] dark:border-[#C85A15]" data-id="element-323">
                <img src={testimonials[activeIndex].image} alt={testimonials[activeIndex].author} className="w-full h-full object-cover" data-id="element-324" />
              </div>
              <div className="flex mb-6" data-id="element-325">
                {[...Array(testimonials[activeIndex].rating)].map((_, i) => <Star key={i} className="text-[#C85A15] fill-[#C85A15]" size={20} data-id="element-326" />)}
              </div>
              <blockquote className="text-xl md:text-2xl italic text-gray-700 dark:text-gray-200 mb-8" data-id="element-327">
                "{testimonials[activeIndex].quote}"
              </blockquote>
              <div data-id="element-328">
                <div className="font-bold text-lg" data-id="element-329">
                  {testimonials[activeIndex].author}
                </div>
                <div className="text-gray-500" data-id="element-330">
                  {testimonials[activeIndex].role}
                </div>
              </div>
            </div>
            <div className="absolute top-1/2 left-4 -translate-y-1/2" data-id="element-331">
              <button onClick={prevTestimonial} className="w-10 h-10 rounded-full bg-white dark:bg-gray-700 shadow-lg flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors" data-id="element-332">
                <ChevronLeft size={20} data-id="element-333" />
              </button>
            </div>
            <div className="absolute top-1/2 right-4 -translate-y-1/2" data-id="element-334">
              <button onClick={nextTestimonial} className="w-10 h-10 rounded-full bg-white dark:bg-gray-700 shadow-lg flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors" data-id="element-335">
                <ChevronRight size={20} data-id="element-336" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-8" data-id="element-337">
          {testimonials.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-3 h-3 rounded-full mx-1 transition-all ${index === activeIndex ? 'bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] w-8' : 'bg-gray-300 dark:bg-gray-600'}`} data-id="element-338" />)}
        </div>
      </div>
    </section>;
}